import { Skeleton } from '@/components/atoms/Skeleton';

export interface BaseProductListingLinkProps {
  isColumnLayout?: boolean;
}

export const LoadingProductListingLink: React.FC<
  BaseProductListingLinkProps
> = ({ isColumnLayout }) => {
  return (
    <div
      className={`flex ${isColumnLayout ? 'flex-col' : ''} flex-grow rounded-small border border-neutral-200`}
    >
      <div
        className={`flex ${isColumnLayout ? 'h-[40%] w-full' : 'h-full w-[40%]'} animate-pulse bg-loading-gradient`}
      />
      <div className="flex flex-grow flex-col justify-between p-l">
        <div className="flex flex-col gap-xl pt-xl">
          <div className="flex h-[32px] w-full animate-pulse rounded-small bg-loading-gradient" />
          <div className="flex h-[32px] w-full animate-pulse rounded-small bg-loading-gradient" />
        </div>
        <div className="flex h-[48px] w-full rounded-small bg-loading-gradient" />
      </div>
    </div>
  );
};
export const VDPComponentLoadingCard = () => {
  return (
    <div className="flex flex-col gap-s">
      <Skeleton className="h-[40px] rounded-small p-xl" />
      <Skeleton className="flex h-[150px] w-full rounded-small ml:h-[200px]" />
      <Skeleton className="h-[40px] rounded-small p-xl" />
      <Skeleton className="flex h-[150px] w-full rounded-small ml:h-[200px]" />
    </div>
  );
};

export const VDPImageGalleryLoadingCard = () => {
  return (
    <div className="grid h-[550px] grid-cols-1 gap-l ml:grid-cols-3 l:grid-cols-4">
      {/* Large left image */}
      <Skeleton className="col-span-2 row-span-2 size-full" />

      {/* Left images */}
      <Skeleton className="hidden size-full ml:block" />
      <Skeleton className="hidden size-full ml:block" />
      <Skeleton className="hidden size-full l:block" />
      <Skeleton className="hidden size-full l:block" />
    </div>
  );
};

export const SellMyCarLiveOfferLoadingCard = () => {
  return (
    <div className="flex flex-col gap-l p-l m:px-[40px] l:px-[60px]">
      <Skeleton className="hidden h-[32px] w-full rounded-small p-l ml:block" />
      <Skeleton className="hidden h-[80px] w-full rounded-small p-l ml:block" />
      <VDPImageGalleryLoadingCard />
      <div className="flex h-[450px] gap-l">
        <Skeleton className="w-full rounded-small p-l ml:block ml:w-2/3" />
        <Skeleton className="hidden w-1/3 rounded-small p-l ml:block" />
      </div>
    </div>
  );
};
